module.exports = __webpack_public_path__ + "img/23.92b6cd1e.gif";